import { useState } from 'react';

const faqs = [
  {
    question: '年会費無料カードは本当にずっと無料ですか？',
    answer: '「永年無料」と記載されているカードは、条件なしでずっと無料です。ただし「初年度無料」や「条件付き無料」のカードもあるため、申込み前に必ず確認しましょう。三井住友カード（NL）、大手ECモール系カード、リクルートカードなどは永年無料です。'
  },
  {
    question: '年会費無料でもポイントは貯まりますか？',
    answer: 'はい、年会費無料カードでもポイントは貯まります。大手ECモール系カードは1.0%、リクルートカードは1.2%と高還元率です。三井住友カード（NL）は対象店舗で最大7%還元と、有料カード以上にお得な場合もあります。'
  },
  {
    question: '年会費無料カードは何枚まで持てますか？',
    answer: '法律上の制限はありませんが、一般的には3～5枚程度が管理しやすい範囲です。維持コストがかからないため、用途別に複数枚持つことで、それぞれの特典を最大限活用できます。'
  },
  {
    question: '年会費無料カードでも海外で使えますか？',
    answer: 'はい、VISA・Mastercard・JCBなどの国際ブランドが付いていれば海外でも使えます。ただし、海外旅行保険の補償額は有料カードより低めです。海外利用が多い方は、保険内容も確認しましょう。'
  },
  {
    question: '学生や主婦でも年会費無料カードは作れますか？',
    answer: '18歳以上（高校生を除く）で安定した収入があれば申込み可能です。学生の場合は親権者の同意が必要な場合があります。主婦の方は配偶者に収入があれば「配偶者の年収」で申込めるカードもあります。'
  },
  {
    question: '年会費無料カードから有料カードへ切り替えできますか？',
    answer: 'はい、多くのカード会社では無料カードから有料カード（ゴールドカードなど）へのアップグレードが可能です。利用実績を積むことで、カード会社から招待（インビテーション）が届くこともあります。'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
          よくある質問（FAQ）
        </h2>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-teal-300 transition-colors"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">Q</span>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg leading-relaxed pr-4">
                    {faq.question}
                  </h3>
                </div>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 pt-2">
                  <div className="flex gap-4 ml-0">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-sm">A</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed flex-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-10 text-center">
          <p className="text-gray-600 mb-4">その他のご質問がある場合は、各カード会社の公式サイトをご確認ください。</p>
          <a 
            href="#ranking"
            className="inline-block px-8 py-3 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors font-semibold whitespace-nowrap cursor-pointer"
          >
            おすすめカードを見る
          </a>
        </div>
      </div>
    </section>
  );
}
